import { put, delay, call, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import config from '../config';
import Cookies from 'js-cookie';

//Action
import { loadingSet } from '../action/uiAction';


function* searchListGet(action) {

  yield put(loadingSet(true));

  let page = (action.payload.page) ? action.payload.page : 1;

  const {res, err} = yield call(function(payload) {
    var params = new URLSearchParams();
    params.append('ULIC', Cookies.get('ULIC'));
    params.append('ULPC', Cookies.get('ULPC'));
    params.append('page', page);
    params.append('timestamp', action.payload.timestamp);

    let lsObj = JSON.parse(localStorage.getItem('SearchCondition'));

    params.append('age[]', lsObj.age.low);
    params.append('age[]', lsObj.age.high);

    params.append('distance', lsObj.distance);
    (Array.isArray(lsObj.proof) === true) && lsObj.proof.map( (value, index) => params.append('proof[]', value) );
    (Array.isArray(lsObj.photo) === true) && lsObj.photo.map( (value, index) => params.append('photo[]', value) );

    (lsObj.signinRecent === true) && params.append('signinRecent', 'check');
    (lsObj.postCheck === true) && params.append('postCheck', 'check');
    (lsObj.qaCheck === true) && params.append('qaCheck', 'check');

    if (lsObj.keyword) {
      lsObj.keyword.split(" ").map( (value, index) => params.append('keyword[]', value) );
    }

    if (lsObj.name) {
      params.append('name', lsObj.name);
    }
    params.append('loginLimit', lsObj.loginLimit);

    (Array.isArray(lsObj.region) === true) && lsObj.region.map( (value, index) => params.append('region[]', value) );
    (Array.isArray(lsObj.marriage) === true) && lsObj.marriage.map( (value, index) => params.append('marriage[]', value) );
    (Array.isArray(lsObj.job) === true) && lsObj.job.map( (value, index) => params.append('job[]', value) );
    (Array.isArray(lsObj.academic) === true) && lsObj.academic.map( (value, index) => params.append('academic[]', value) );
    (Array.isArray(lsObj.lifestyle) === true) && lsObj.lifestyle.map( (value, index) => params.append('lifestyle[]', value) );

    params.append('height[]', lsObj.height.low);
    params.append('height[]', lsObj.height.high);

    (Array.isArray(lsObj.style) === true) && lsObj.style.map( (value, index) => params.append('style[]', value) );
    (Array.isArray(lsObj.association) === true) && lsObj.association.map( (value, index) => params.append('association[]', value) );
    (Array.isArray(lsObj.child) === true) && lsObj.child.map( (value, index) => params.append('child[]', value) );
    (Array.isArray(lsObj.smorking) === true) && lsObj.smorking.map( (value, index) => params.append('smorking[]', value) );
    (Array.isArray(lsObj.drinking) === true) && lsObj.drinking.map( (value, index) => params.append('drinking[]', value) );
    (Array.isArray(lsObj.gambling) === true) && lsObj.gambling.map( (value, index) => params.append('gambling[]', value) );
    (Array.isArray(lsObj.pet) === true) && lsObj.pet.map( (value, index) => params.append('pet[]', value) );
    (Array.isArray(lsObj.blood) === true) && lsObj.blood.map( (value, index) => params.append('blood[]', value) );
    (Array.isArray(lsObj.constellation) === true) && lsObj.constellation.map( (value, index) => params.append('constellation[]', value) );
    (Array.isArray(lsObj.income) === true) && lsObj.income.map( (value, index) => params.append('income[]', value) );
    (Array.isArray(lsObj.personality) === true) && lsObj.personality.map( (value, index) => params.append('personality[]', value) );
    (Array.isArray(lsObj.opposite) === true) && lsObj.opposite.map( (value, index) => params.append('opposite[]', value) );

    return axios.post(config.apiUri + "member/searchListApi.php", params, {
      timeout: 10000
    })
    .then((res) => {
      return {res};
    })
    .catch((err) => {
      return {err};
    })
  }, action.payload);
  yield delay(100);
  if (res) {
    if (res.data.bool) {
      yield put({
        type: "SEARCH_LIST_SET",
        payload: {
          list: res.data.list,
          page: page,
          isListNext: res.data.isListNext,
          timestamp: action.payload.timestamp,
        },
      });
      action.callback();
    }
  }

  if (err) {
    yield put({ type: 'SNACK_SET', payload: {visible: true, severity: 'error', duration: 5000, comment: config.apiErrComment} });
  }

  yield put(loadingSet(false));
}

function* searchConditionListGet(action) {
  const {res, err} = yield call(function(payload) {
    const params = new URLSearchParams();
    params.append('ULIC', Cookies.get('ULIC'));
    params.append('ULPC', Cookies.get('ULPC'));
    return axios.post(config.apiUri + "member/searchConditionListApi.php", params, {
      timeout: 5000
    })
    .then((res) => {
      return {res};
    })
    .catch((err) => {
      return {err};
    })
  }, action.payload);

  if (res) {
    if (res.data.bool) {
      yield put({
        type: "SEARCH_CONDITION_LIST_SET",
        payload: {
          list: res.data.list,
        },
      });
    }
  }
  if (err) {
    yield put({ type: 'SNACK_SET', payload: {visible: true, severity: 'error', duration: 5000, comment: config.apiErrComment} });
  }

  yield put(loadingSet(false));
}


function* searchConditionSave(action) {

  yield put(loadingSet(true));

  const {res, err} = yield call(function(payload) {
    var params = new URLSearchParams();
    params.append('ULIC', Cookies.get('ULIC'));
    params.append('ULPC', Cookies.get('ULPC'));
    params.append('type', 'add');
    params.append('conditionName', payload.conditionName);

    let condition = payload.condition;
    params.append('region', condition.region.join(',') );
    params.append('marriage', condition.marriage.join(',') );
    params.append('job', condition.job.join(',') );
    params.append('academic', condition.academic.join(',') );
    params.append('lifestyle', condition.lifestyle.join(',') );
    params.append('style', condition.style.join(',') );
    params.append('association', condition.association.join(',') );
    params.append('child', condition.child.join(',') );
    params.append('smorking', condition.smorking.join(',') );
    params.append('drinking', condition.drinking.join(',') );
    params.append('gambling', condition.gambling.join(',') );
    params.append('pet', condition.pet.join(',') );
    params.append('blood', condition.blood.join(',') );
    params.append('constellation', condition.constellation.join(',') );
    params.append('income', condition.income.join(',') );
    params.append('personality', condition.personality.join(',') );
    params.append('opposite', condition.opposite.join(',') );
    params.append('ageLow', condition.age.low);
    params.append('ageHigh', condition.age.high);
    params.append('heightLow', condition.height.low);
    params.append('heightHigh', condition.height.high);
    params.append('distance', condition.distance);
    params.append('signinRecent', (condition.signinRecent === true) ? 'check': '' );
    params.append('postCheck', (condition.postCheck === true) ? 'check': '' );
    params.append('qaCheck', (condition.qaCheck === true) ? 'check': '' );

    params.append('proof', condition.proof.join(',') );
    params.append('photo', condition.photo.join(',') );

    params.append('keyword', condition.keyword);

    params.append('name', condition.name);
    params.append('loginLimit', condition.loginLimit);

    return axios.post(config.apiUri + "member/searchConditionEditApi.php", params, {
      timeout: 10000
    })
    .then((res) => {
      return {res};
    })
    .catch((err) => {
      return {err};
    })
  }, action.payload);

  if (res) {
    if (res.data.bool) {
      yield delay(500);
      yield put({type: "SEARCH_CONDITION_LIST_GET"});
    }
  }
  if (err) {
    yield put({ type: 'SNACK_SET', payload: {visible: true, severity: 'error', duration: 5000, comment: config.apiErrComment} });
  }
  yield put(loadingSet(false));
}


function* searchConditionItemDel(action) {
  const {res, err} = yield call(function(payload) {
    const params = new URLSearchParams();
    params.append('ULIC', Cookies.get('ULIC'));
    params.append('ULPC', Cookies.get('ULPC'));
    params.append('type', 'del');
    params.append('id', payload.id);
    return axios.post(config.apiUri + "member/searchConditionEditApi.php", params, {
      timeout: 5000
    })
    .then((res) => {
      return {res};
    })
    .catch((err) => {
      return {err};
    })
  }, action.payload);

  if (res) {
    if (res.data.bool) {
      yield delay(500);
      yield put({type: "SEARCH_CONDITION_LIST_GET"});
    }
  }

  if (err) {
    yield put({ type: 'SNACK_SET', payload: {visible: true, severity: 'error', duration: 5000, comment: config.apiErrComment} });
  }

  yield put(loadingSet(false));
}

const saga = [
  takeLatest('SEARCH_LIST_GET', searchListGet),
  takeLatest('SEARCH_CONDITION_LIST_GET', searchConditionListGet),
  takeLatest('SEARCH_CONDITION_SAVE', searchConditionSave),
  takeLatest('SEARCH_CONDITION_ITEM_DEL', searchConditionItemDel),
];

export default saga;
